import React, { useState, useEffect, useRef } from "react";
import image1 from "../../Assets/Images/seekjob/bannerone.png";
import image2 from "../../Assets/Images/seekjob/bannertwo.png";
import image3 from "../../Assets/Images/seekjob/bannerthree.png";
import image4 from "../../Assets/Images/seekjob/graph-main.png";
import image5 from "../../Assets/Images/seekjob/2nd image insider network.png";
import image6 from "../../Assets/Images/seekjob/new-frameimage.png";
import image7 from "../../Assets/Images/seekjob/1st Image Generate score.png";
import { useNavigate } from "react-router-dom";

const SlideSection = () => {
  const navigate = useNavigate();
  const slideData = [
    {
      id: 1,
      titleLine1: "Find Your Future Faster.",
      titleLine2: "Your Path to Succeed.",
      description: "AI-powered connections linking education to opportunity.",
      image1: image1,
      image2: image2,
      image3: image3,
    },
    {
      id: 2,
      titleLine1: "Career Connections",
      titleLine2: "That Matter.",
      description:
        "Custom job recommendations tailored to your unique skills and goals.",
      image1: image4,
      image2: image5,
      image3: "",
    },
    {
      id: 3,
      titleLine1: "AI-Matched Careers",
      titleLine2: "With Human Success.",
      description: "AI-powered connections linking education to opportunity.",
      image1: image6,
      image2: image7,
      image3: "",
    },
  ];

  const [currentSlideIndex, setCurrentSlideIndex] = useState(1);
  const [outgoingSlideContent, setOutgoingSlideContent] = useState(null); // Stores the slide that is exiting
  const [animationKey, setAnimationKey] = useState(0); // To force re-render/re-animation of incoming elements

  const animationDuration = 800; // Match CSS animation duration (0.7s)
  const timeoutRef = useRef(null); // Ref to hold the timeout ID for cleanup

  // Effect for automatic slide transition
  useEffect(() => {
    const slideInterval = setInterval(() => {
      const nextIndex = (currentSlideIndex + 1) % slideData.length;
      handleSlideChange(nextIndex); // Use the unified slide change handler
    }, 5000);

    return () => clearInterval(slideInterval);
  }, [currentSlideIndex, slideData.length]); // Depend on currentSlideIndex for sequential updates

  // Unified function to handle slide changes (both auto and manual)
  const handleSlideChange = (newIndex) => {
    if (newIndex === currentSlideIndex) return;

    // Clear any existing timeout to prevent unexpected behavior
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    // Set the current slide as the outgoing slide for exit animation
    setOutgoingSlideContent(slideData[currentSlideIndex]);

    // Update the current slide index to the new slide
    setCurrentSlideIndex(newIndex);

    // Increment animationKey to force re-animation of incoming elements (including text)
    setAnimationKey((prev) => prev + 1);

    // Set a timeout to clear the outgoing slide content after its animation finishes
    timeoutRef.current = setTimeout(() => {
      setOutgoingSlideContent(null);
    }, animationDuration);
  };

  // Clean up timeout on component unmount
  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  const currentSlideContent = slideData[currentSlideIndex];

  // Helper to get animation class for outgoing images based on slide rules
  const getOutgoingImageAnimation = (imageNumber, slideId) => {
    if (!outgoingSlideContent) return "";

    if (slideId === 1 && imageNumber === 2) {
      return "tw-animate-fade-out-slow"; // Only apply this for image2 of slide 1
    }
    // For all other cases, apply slide-out-right (or your default)
    return "tw-animate-slide-out-right";
  };
  const handleClick = () => {
    navigate('/employer#ContactUs');
  };

  return (
    <div style={{ marginTop: "65px" }} className="tw-overflow-hidden tw-relative  tw-text-white tw-font-inter">
      {/* Tailwind CSS keyframe animations */}
      <style>{`
                @keyframes slideInFromRight {
                    0% { transform: translateX(100%); opacity: 0; }
                    100% { transform: translateX(0); opacity: 1; }
                }
                @keyframes fadeInUp {
                    0% { transform: translateY(20px); opacity: 0; }
                    100% { transform: translateY(0); opacity: 1; }
                }
                @keyframes slideOutRight {
                    0% { transform: translateX(0); opacity: 1; }
                    100% { transform: translateX(100%); opacity: 0; }
                }
                @keyframes fadeOutSlow {
                    0% { opacity: 1; }
                    100% { opacity: 0; }
                }

                /* Animation classes */
                .tw-animate-slide-in-right { animation: slideInFromRight 0.9s ease-out forwards; }
                .tw-animate-fade-in-up { animation: fadeInUp 0.8s ease-out forwards; }
                .tw-animate-slide-out-right { animation: slideOutRight 0.9s ease-out forwards; }
                .tw-animate-fade-out-slow { animation: fadeOutSlow 1s ease-out forwards; }
            `}</style>

      <div className="tw-relative tw-z-10  tw-flex tw-items-center tw-justify-center  tw-px-4">
        <div className="tw-container tw-mx-auto tw-flex tw-flex-col md:tw-flex-row tw-items-center md:tw-items-start tw-justify-between">
          {/* Left Section: Text Content (for incoming slide) */}
          {/* Key ensures React re-renders this div and re-applies entry animation on slide change */}
          <div
            key={`incoming-text-${animationKey}`}
            className={`tw-text-center md:tw-text-left tw-mb-12 md:tw-mb-0 md:tw-w-[45%] lg:tw-w-4/5 tw-mt-[20px] md:tw-mt-[225px]`}
          >


            <h1 className="tw-font-extrabold tw-mb-6 tw-text-4xl sm:tw-text-5xl md:tw-text-[45px] tw-leading-tight sm:tw-leading-snug md:tw-leading-[60px] tw-text-center sm:tw-text-left tw-animate-fade-in-up">
              <span
                style={{
                  background: "linear-gradient(to right, #0843FE, #4995FB)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                  backgroundClip: "text",
                  textFillColor: "transparent",
                  fontWeight: "600",

                }}
                className="tw-block"
              >
                {currentSlideContent.titleLine1}
              </span>

              <span
                style={{
                  color: "#FFFFFF",
                  fontWeight: "600",
                  textShadow:
                    "0 0 20px rgba(49, 118, 206, 0.7), 0 0 30px rgba(49, 118, 206, 0.7)",
                }}
                className="tw-block"
              >
                {currentSlideContent.titleLine2}
              </span>
            </h1>

            <p
              className="tw-text-[23px] tw-text-gray-300 tw-mb-8 tw-max-w-lg tw-mx-auto md:tw-mx-0"
              style={{ fontWeight: "600" }}
            >
              {currentSlideContent.description}
            </p>

            <div className="tw-text-[16px] tw-flex tw-flex-col sm:tw-flex-row tw-space-y-4 sm:tw-space-y-0 sm:tw-space-x-4">
              <button onClick={() => navigate("/sign-up")} className="tw-border-none tw-inline-block tw-bg-gradient-to-r tw-from-[#0843FE] tw-to-[#4995FB] tw-text-white tw-font-medium tw-py-3 tw-px-8 tw-rounded-md tw-transition tw-duration-300 tw-ease-in-out">
                Try SeekJobs For Free
              </button>
              <button
                className="tw-text-[16px] tw-bg-white tw-text-black tw-border tw-border-white tw-font-semibold tw-py-3 tw-px-8 tw-rounded-lg tw-transition tw-duration-300 hover:tw-bg-black hover:tw-text-white"
                onClick={handleClick}
              >
                Post a Job for Free
              </button>
            </div>
          </div>

          {/* Right Section: Images Container */}
          <div className="tw-relative md:tw-w-1/2 lg:tw-w-[45%] xl:tw-w-[40%] tw-h-[450px] sm:tw-h-[550px] md:tw-h-[650px] lg:tw-h-[750px]  tw-mt-10 md:tw-mt-0">
            {/* Outgoing Images */}
            {outgoingSlideContent && (
              <div className="tw-absolute tw-inset-0 tw-pointer-events-none">
                {/* Image 1 (Outgoing) */}
                {outgoingSlideContent.image1 && (
                  <div
                    key={`outgoing-${outgoingSlideContent.id}-img1`}
                    className={`tw-absolute tw-w-[30%] sm:tw-w-[40%] md:tw-w-[45%] lg:tw-w-[40%] xl:tw-w-[35%] tw-h-[30%] tw-top-[5%] tw-right-[0%] tw-z-10 tw-transform tw--rotate-5 ${getOutgoingImageAnimation(
                      1,
                      outgoingSlideContent.id
                    )}`}
                  >
                    <img
                      src={outgoingSlideContent.image1}
                      alt="Outgoing Image 1"
                    />
                  </div>
                )}

                {/* Image 2 (Outgoing) */}
                {outgoingSlideContent.image2 && (
                  <div
                    key={`outgoing-${outgoingSlideContent.id}-img2`}
                    className={`${outgoingSlideContent.id
                      } tw-absolute tw-w-[35%] sm:tw-w-[40%] md:tw-w-[60%] lg:tw-w-[60%] xl:tw-w-[50%] tw-h-[45%]
            ${outgoingSlideContent.id === 2
                        ? "tw-top-1/3 tw-right-1/2 tw-transform tw--translate-x-1/2 tw--translate-y-1/2"
                        : outgoingSlideContent.id === 3
                          ? "tw-bottom-[-15%] tw-left-[-45%] tw-transform tw--translate-x-1/2"
                          : "tw-top-[5%]"
                      }
            tw-z-30 tw-rotate-8 ${getOutgoingImageAnimation(
                        2,
                        outgoingSlideContent.id
                      )}
          `}
                  >
                    <img
                      src={outgoingSlideContent.image2}
                      alt="Outgoing Image 2"
                      style={{ width: "150%" }}
                    />
                  </div>
                )}

                {/* Image 3 (Outgoing) */}
                {outgoingSlideContent.image3 && (
                  <div
                    key={`outgoing-${outgoingSlideContent.id}-img3`}
                    className={`tw-absolute tw-w-[75%] sm:tw-w-[65%] md:tw-w-[70%] lg:tw-w-[80%] xl:tw-w-[70%] tw-h-[45%]
            ${outgoingSlideContent.id === 1
                        ? " tw-transform tw--translate-x-1/2"
                        : " tw-transform tw-translate-x-[-50%]"
                      }
            tw-z-20 tw-rotate-2 ${getOutgoingImageAnimation(
                        3,
                        outgoingSlideContent.id
                      )}
          `}
                  >
                    <img
                      src={outgoingSlideContent.image3}
                      alt="Outgoing Image 3"
                      style={{ width: "80%" }}
                    />
                  </div>
                )}
              </div>
            )}

            {/* Incoming Images */}
            <div className="tw-absolute tw-inset-0 tw-z-40">
              {/* Image 1 (Incoming) */}
              {currentSlideContent.image1 && (
                <div
                  key={`incoming-${currentSlideContent.id}-img1-${animationKey}`}
                  className={`tw-absolute tw-w-[50%] sm:tw-w-[60%] md:tw-w-[55%] lg:tw-w-[50%] xl:tw-w-[70%] tw-h-[40%] tw-top-[22%] tw-right-[0%] tw-z-10 tw-transform tw--rotate-5 tw-animate-slide-in-right`}
                >
                  <img
                    src={currentSlideContent.image1}
                    alt="Image 1"
                    style={{ height: "463px", width: "auto" }}
                  />
                </div>
              )}

              {/* Image 2 (Incoming) */}
              {currentSlideContent.image2 && (
                <div
                  key={`incoming-${currentSlideContent.id}-img2-${animationKey}`}
                  className={`tw-absolute tw-w-[45%] sm:tw-w-[40%] md:tw-w-[70%] lg:tw-w-[80%] xl:tw-w-[80%] sm:tw-h-[300px] md:tw-h-[45%] lg:tw-h-[45%]
        ${currentSlideContent.id === 2
                      ? "tw-top-1/3 tw-right-1/2 tw-transform tw--translate-x-1/2 tw--translate-y-1/2"
                      : currentSlideContent.id === 3
                        ? "tw-bottom-[-15%] tw-left-[-120px] tw-transform tw--translate-x-1/2"
                        : "tw-top-[5%]"
                    }
        tw-z-30 tw-rotate-8 tw-animate-slide-in-right
    `}
                  style={{
                    left:
                      (window.innerWidth < 950 && currentSlideContent.id === 3) ? "0px" : undefined,
                    top:
                      currentSlideContent.id === 3
                        ? "495px"
                        : currentSlideContent.id === 1
                          ? "0px"
                          : currentSlideContent.id === 2 ? "261px" : "335px",
                    right: currentSlideContent.id === 1 ? "180px" : currentSlideContent.id === 2 ? "150px" : "309px",
                  }}
                >
                  <img
                    src={currentSlideContent.image2}
                    alt="Image 2"
                    style={{
                      width: currentSlideContent.id === 3 ? "190%" : (window.innerWidth < 768 && currentSlideContent.id === 2) ? "500px" : "auto",
                      height: (window.innerWidth < 768 && currentSlideContent.id === 1) ? "300px" : undefined
                    }}
                  />
                </div>
              )}

              {/* Image 3 (Incoming) */}
              {currentSlideContent.image3 && (
                <div
                  key={`incoming-${currentSlideContent.id}-img3-${animationKey}`}
                  className={`tw-absolute tw-w-[75%] sm:tw-w-[65%] md:tw-w-[70%] lg:tw-w-[80%] xl:tw-w-[70%] tw-h-[45%]tw-top-[310px] sm:tw-top-[310px] md:tw-top-[553px] lg:tw-top-[553px]
        ${currentSlideContent.id === 1
                      ? "tw-bottom-[-5%] sm:tw-absolute sm:tw-left-[-4%] lg:tw-right-[100%] tw-transform tw--translate-x-1/2"
                      : currentSlideContent.id === 0 ? "sm:tw-left-[-2%]" : "tw-bottom-[45%] lg:tw-left-[5%]  tw-transform tw-translate-x-[-50%]"
                    }
        tw-z-20 tw-rotate-2 tw-animate-slide-in-right
    `}
                  style={{ left: (window.innerWidth < 768 && currentSlideContent.id === 1) ? "-180px" : undefined }}
                >
                  <img
                    src={currentSlideContent.image3}
                    alt="Image 3"
                    style={{ width: (window.innerWidth <= 768 && currentSlideContent.id == 1) ? "430px" : "592px" }}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Slide Navigation Dots */}
      {/* <div className="tw-absolute tw-bottom-8 tw-left-1/2 tw-transform -tw-translate-x-1/2 tw-flex tw-space-x-3 tw-z-20">
                {slideData.map((_, index) => (
                    <div
                        key={index}
                        className={`tw-w-3 tw-h-3 tw-rounded-full tw-transition-all tw-duration-300
                ${index === currentSlideIndex ? 'tw-bg-blue-600 tw-scale-125' : 'tw-bg-gray-400'}
            `}
                        aria-label={`Slide ${index + 1}`}
                    ></div>
                ))}
            </div> */}
    </div>
  );
};

export default SlideSection;
